import { Tab } from './tab';

export class Item {
  constructor(
    public tabs?: Tab[],
    public handlers?: { onloadscript: string, onsavescript: string },
  ) { }
}
